import Articles from "./Articles"
import CaseStudies from "./CaseStudies"

export default {
  Articles,
  CaseStudies,
}
